import React, { useEffect, useState } from 'react';
import './Customerreportprint.css';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { useTranslation } from "react-i18next";

// ✅ FIX: fontBase must NOT use i18n here (i18n not available yet)
// Using i18next stored language from localStorage
const lang = (localStorage.getItem("i18nextLng") || "mr").toLowerCase().slice(0, 2);
const fontBase = (lang === "kn") ? "Kannada" : "Lato-Italic";

Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});
Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});

const Customerreportprint = (props) => {
  const { t, i18n } = useTranslation();

  // ✅ REMOVE this line (because styles use top fontBase already)
  // const fontBase = (i18n.language === "kn") ? "Kannada" : "Lato-Italic";

  const [customerData, setCustomerData] = useState({});
  const [literTotal, setLiterTotal] = useState(0);
  const [amtTotal, setAmtTotal] = useState(0);
  let totals = {};

  useEffect(() => {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    let phplanding = "";
    if (localStorage.getItem("khateflag") === "bybill") {
      phplanding = "getcustreport.php";
    }
    else if (localStorage.getItem("khateflag") === "bysingle") {
      phplanding = "getsinglekhate4.php";
    }

    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      kno: localStorage.getItem("knoprint"),
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      setCustomerData(response.data);
    }).catch(err => {
      console.log(err);
    });
  }, []);

  // helpers
  const chunk = (arr, size) => {
    if (!Array.isArray(arr) || size <= 0) return [];
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const num = (v) => {
    const n = Number(String(v ?? "").replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  const getDatesInRange = (date1, date2) => {
    const dates = [];
    const currentDate = new Date(date1);

    while (currentDate <= new Date(date2)) {
      dates.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  function formatDate(inputDate) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(inputDate).toLocaleDateString('en-US', options);
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const recordsPerPage = 5;

  // ✅ NEW: stable reporttype code (works for any language)
  const reportType = (localStorage.getItem("reporttype_code") || "").toUpperCase();

  return (
    <PDFViewer className='pdf'>
      <Document>
        {customerData.length > 0 ? (
          localStorage.getItem("khateflag") === "bybill" ?
            <Page size="A4" orientation="landscape">
              <Text style={styles.latoText}>{customerData[0].kendra}</Text>

              <Text style={styles.latoText}>
                {t("customerreportprint.titles.customerAccountReport")}
              </Text>

              <Text style={styles.latoText2}>
                {t("customerreportprint.labels.memberName") + (customerData[0].cname || "")}
              </Text>

              <Text style={styles.latoText2}>
                {t("customerreportprint.labels.period") +
                  formatDate(localStorage.getItem("date1print")) +
                  "   " + t("common.to") + "   " +
                  formatDate(localStorage.getItem("date2print"))}
              </Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={[styles.tableHeadervadhtutspan, { flex: 1 }]}>-</Text>
                  <Text style={[styles.tableHeadervadhtutspan, { flex: 1 }]}>-</Text>

                  {reportType === "ADVANCE" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 5 }]}>
                      {t("customerreportprint.reportTypes.advance")}
                    </Text> : ''}

                  {reportType === "KHADYA" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 5 }]}>
                      {t("customerreportprint.reportTypes.khadya")}
                    </Text> : ''}

                  {reportType === "RATIB" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 5 }]}>
                      {t("customerreportprint.reportTypes.ratib")}
                    </Text> : ''}

                  {reportType === "LOAN" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 6 }]}>
                      {t("customerreportprint.reportTypes.loan")}
                    </Text> : ''}

                  {reportType === "SANGH" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 5 }]}>
                      {t("customerreportprint.reportTypes.sangh")}
                    </Text> : ''}

                  {reportType === "RETAN" ?
                    <Text style={[styles.tableHeadervadhtutlastspan, { flex: 6 }]}>
                      {t("customerreportprint.reportTypes.retan")}
                    </Text> : ''}
                </View>

                <View style={styles.tableRowdata}>
                  <Text style={styles.tableHeader}>
                    {t("customerreportprint.table.billPeriod")}
                  </Text>
                  <Text style={styles.tableHeader}>
                    {t("customerreportprint.table.bill")}
                  </Text>

                  {(reportType === "ADVANCE" || reportType === "KHADYA" || reportType === "RATIB" || reportType === "SANGH") ?
                    <>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.previous")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.current")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.total")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.deduction")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.balance")}</Text>
                    </> : ''}

                  {reportType === "LOAN" ?
                    <>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.previous")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.current")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.total")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.deduction")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.interest")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.balance")}</Text>
                    </> : ''}

                  {reportType === "RETAN" ?
                    <>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.previous")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.current")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.total")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.salaryDeductionShort")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.medicineDeductionShort")}</Text>
                      <Text style={styles.tableHeader}>{t("customerreportprint.table.balance")}</Text>
                    </> : ''}

                </View>

                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRowdata}>
                    <Text style={styles.tableCell}>
                      {rowData.date1.substr(5).split('-').reverse().join('/') + " " + t("common.to") + " " + rowData.date2.substr(5).split('-').reverse().join('/')}
                    </Text>

                    <Text style={styles.tableCell}>{parseFloat(rowData.billamt).toFixed(2)}</Text>

                    {reportType === "ADVANCE" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.madv).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.cadv).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tadv).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.advkapat).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newadv).toFixed(2)}</Text>
                      </> : ''}

                    {reportType === "KHADYA" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.mkhadya).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.ckhadya).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tkhadya).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.khadyakapat).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newkhadya).toFixed(2)}</Text>
                      </> : ''}

                    {reportType === "RATIB" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.mratib).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.cratib).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tratib).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.ratibkapat).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newratib).toFixed(2)}</Text>
                      </> : ''}

                    {reportType === "LOAN" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.mkarj).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.ckarj).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tkarj).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.karjhpta).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.karjintr).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newkarj).toFixed(2)}</Text>
                      </> : ''}

                    {reportType === "SANGH" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.magilsangh).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.csangh).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tsangh).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.sanghkapat).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newsangh).toFixed(2)}</Text>
                      </> : ''}

                    {reportType === "RETAN" ?
                      <>
                        <Text style={styles.tableCell}>{parseFloat(rowData.magilretanmedi).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.cretanmedi).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.tretanmedi).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.retan).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.medi).toFixed(2)}</Text>
                        <Text style={styles.tableCell}>{parseFloat(rowData.newretanmedi).toFixed(2)}</Text>
                      </> : ''}

                  </View>
                ))}
              </View>
            </Page>

            : localStorage.getItem("khateflag") === "bysingle" ?
              (() => {
                const Recordpages = chunk(customerData || [], 17);
                const hdr = (customerData && customerData[0]) ? customerData[0] : {};
                const d1 = formatDate(localStorage.getItem("date1print"));
                const d2 = formatDate(localStorage.getItem("date2print"));

                const openingBal = num(hdr.opening_balance);
                const totalNave = (customerData || []).reduce((tSum, r) => tSum + num(r.nave), 0);
                const totalJma = (customerData || []).reduce((tSum, r) => tSum + num(r.jma), 0);

                return Recordpages.map((pageRows, pageIndex) => (
                  <Page key={pageIndex} size="A4">
                    <Text style={styles.latoText}>{hdr.kendra}</Text>

                    <Text style={styles.latoText}>
                      {t("customerreportprint.titles.personalLedger")}
                    </Text>

                    <Text style={styles.latoText2}>
                      {t("customerreportprint.labels.memberName") + (hdr.cname || "")}
                    </Text>

                    {pageIndex === 0 && (
                      <Text style={styles.latoText2}>
                        {t("customerreportprint.labels.openingBalance") + openingBal.toFixed(2)}
                      </Text>
                    )}

                    <Text style={styles.latoText2}>
                      {t("customerreportprint.labels.period") + d1 + "   " + t("common.to") + "   " + d2}
                    </Text>

                    <View style={styles.table}>
                      <View style={styles.tableRow}>
                        <Text style={styles.tableHeaderfirst}>
                          {t("customerreportprint.table.date")}
                        </Text>
                        <Text style={styles.tableHeadersecond}>
                          {t("customerreportprint.table.details")}
                        </Text>
                        <Text style={styles.tableHeaderfirst}>
                          {t("customerreportprint.table.debit")}
                        </Text>
                        <Text style={styles.tableHeaderfirst}>
                          {t("customerreportprint.table.credit")}
                        </Text>
                        <Text style={styles.tableHeaderlastsingle}>
                          {t("customerreportprint.table.balance")}
                        </Text>
                      </View>

                      {pageRows.map((rowData, index) => (
                        <View key={`${pageIndex}-${index}`} style={styles.tableRowdata} wrap={false}>
                          <Text style={styles.tableCellfirst}>{rowData.date}</Text>
                          <Text style={styles.tableCellsecond}>
                            {(rowData.particular || "") + "\n" + (rowData.remark || "")}
                          </Text>
                          <Text style={styles.tableCellfirst}>{num(rowData.nave).toFixed(2)}</Text>
                          <Text style={styles.tableCellfirst}>{num(rowData.jma).toFixed(2)}</Text>
                          <Text style={styles.tableCellfirst}>{num(rowData.closing_balance).toFixed(2)}</Text>
                        </View>
                      ))}
                    </View>

                    {pageIndex === (Recordpages.length - 1) && (
                      <View style={styles.totalRowWrap}>
                        <View style={styles.totalRow}>
                          <Text style={styles.totalCellDate}>
                            {t("customerreportprint.table.total")}
                          </Text>
                          <Text style={styles.totalCellDetails}>{"-"}</Text>
                          <Text style={styles.totalCellNum}>{totalNave.toFixed(2)}</Text>
                          <Text style={styles.totalCellNum}>{totalJma.toFixed(2)}</Text>
                          <Text style={styles.totalCellNum}>{"-"}</Text>
                        </View>
                      </View>
                    )}

                  </Page>
                ));
              })()
              : ''
        ) : ""}
      </Document>
    </PDFViewer>
  );
};

// styles (existing + added only)

const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    textAlign: 'center',
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
    justifyContent: 'space-between',
  },
  table: {
    display: 'table',
    width: '97%',
    margin: 5,
  },
  tableone: {
    display: 'table',
    width: '18%',
    margin: 5,
  },
  tableCellone: {
    border: '0.5px solid lightgray',
    padding: 0.5,
    fontSize: 8,
    fontFamily: fontBase,
    textAlign: 'center',
    flex: 1,
  },
  tableRowone: {
    flexDirection: 'row',
    width: '100%',
  },
  tableHeaderone: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '1px solid #000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
    flex: 1,
  },

  tableRow: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
  },
  tableRowdata: {
    flexDirection: 'row',
  },
  tableRow2: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
    marginTop: 5,
  },

  tableRow3: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
    marginTop: 10,
  },
  line: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
    marginTop: 5,
    height: 1,
    width: '100vw',
    marginBottom: 5,
  },
  tableHeader: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    padding: 2,
    flex: 0.5,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 9,
  },
  tableHeaderlast: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    borderColor: 'black',
    padding: 2,
    flex: 0.5,
    textAlign: 'center',
    fontSize: 10,
  },
  tableHeaderfirst: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    padding: 2,
    borderColor: 'black',
    textAlign: 'center',
    fontSize: 10,
    width: '80px'
  },

  tableHeaderlastsingle: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    padding: 2,
    borderColor: 'black',
    textAlign: 'center',
    fontSize: 10,
    width: '80px'
  },

  tableHeadersecond: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    padding: 2,
    borderColor: 'black',
    textAlign: 'center',
    fontSize: 9,
    width: '250px'
  },

  tableCell: {
    border: '0.5px solid black',
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontFamily: fontBase,
    width: 2,
    textAlign: 'center',
  },

  tableCellfirst: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '0.5px solid black',
    padding: 2,
    textAlign: 'center',
    fontSize: 10,
    width: '80px'
  },

  tableCellsecond: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '0.5px solid black',
    padding: 2,
    paddingLeft: 10,
    textAlign: 'start',
    fontSize: 10,
    width: '250px'
  },

  tableCellgreen: {
    border: '0.5px solid black',
    padding: 0.5,
    flex: 1,
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: fontBase,
    color: 'green',
    width: 2,
    textAlign: 'center',
  },
  tableCellred: {
    border: '0.5px solid black',
    padding: 0.5,
    flex: 1,
    fontSize: 9,
    fontWeight: 'bold',
    fontFamily: fontBase,
    color: 'red',
    width: 2,
    textAlign: 'center',
  },
  latoTextlarge: {
    fontFamily: fontBase,
    fontSize: 15,
    marginBottom: 5,
    textAlign: 'center',
    width: '100vw',
    fontWeight: 'bold',
    marginTop: 5,
  },
  latoText: {
    fontFamily: fontBase,
    fontSize: 14,
    marginBottom: 5,
    textAlign: 'center',
    width: '100vw',
    fontWeight: 'bold',
    marginTop: 5,
  },
  latoText2: {
    fontFamily: fontBase,
    fontSize: 11,
    textAlign: 'center',
    width: '100vw',
    fontWeight: 'bold',
  },
  headtextsmall: {
    fontFamily: fontBase,
    fontSize: 10,
    fontWeight: 'bold',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
  },
  row1: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 5,
    paddingRight: 5,
  },
  row2: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 140,
    paddingRight: 140,
    backgroundColor: 'lightgray',
  },
  column1: {
    display: 'flex',
    flexDirection: 'column',
    width: '19%',
    justifyContent: 'start',
    alignItems: 'flex-start',
    paddingLeft: 5,
    paddingRight: 5,
    marginLeft: 20,
  },
  column2: {
    display: 'flex',
    flexDirection: 'column',
    width: '15%',
    justifyContent: 'start',
    alignItems: 'flex-start',
    paddingLeft: 5,
    paddingRight: 5,
  },
  column3: {
    display: 'flex',
    flexDirection: 'column',
    width: '17%',
    justifyContent: 'start',
    alignItems: 'flex-start',
    paddingLeft: 5,
    paddingRight: 5,
    marginLeft: 20,
  },
  column1Row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  column1Rowgray: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 6,
    marginTop: 5,
    border: '0.5px solid black',
    backgroundColor: 'lightgray'
  },
  column1Label: {
    fontFamily: fontBase,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  column1Value: {
    fontFamily: fontBase,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  pageBreak: {
    pageBreakBefore: 'always',
  },
  totalsRow: {
    flexDirection: 'row',
    borderTop: '1px solid #000',
    paddingTop: 5,
    paddingLeft: 2,
  },
  totalsCell: {
    border: '0.5px solid lightgray',
    padding: 0.5,
    flex: 1,
    fontSize: 8,
    width: 2,
    textAlign: 'center',
  },
  imagerow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: 80,
    height: "auto",
    marginLeft: -15,
    marginTop: 5
  },
  imgtext: {
    fontFamily: fontBase,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  tableHeadervadhtutspan: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    padding: 2,
    flex: 0.5,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 10,
  },

  tableHeadervadhtutlast: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderStyle: 'solid',
    padding: 2,
    flex: 0.5,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 8,
  },

  tableHeadervadhtutlastspan: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    padding: 2,
    flex: 0.5,
    borderColor: 'lightblack',
    textAlign: 'center',
    fontSize: 10,
  },

  // ✅ Added styles for total row (bysingle)
  totalRowWrap: {
    width: '97%',
    marginLeft: 5,
    marginRight: 5,
  },
  totalRow: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
  },
  totalCellDate: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '0.5px solid black',
    padding: 2,
    textAlign: 'center',
    fontSize: 10,
    width: '80px',
  },
  totalCellDetails: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '0.5px solid black',
    padding: 2,
    textAlign: 'center',
    fontSize: 10,
    width: '250px',
  },
  totalCellNum: {
    fontFamily: fontBase,
    fontWeight: 'bold',
    border: '0.5px solid black',
    padding: 2,
    textAlign: 'center',
    fontSize: 10,
    width: '80px',
  },
});

export default Customerreportprint;
